<div class="flex flex-col gap-[24px] lt-md:gap-[16px]">
  <h2 data-at-title>
    {{ '+BOOKING.OVERVIEW.PACKAGES.UNREGISTERED' | translate }}
  </h2>

  <div class="unregistered-subscriptions-container">
    <app-booking-subscription-details
      *ngFor="let unregisteredSubscription of unregisteredSubscriptions"
      [subscription]="unregisteredSubscription"
    ></app-booking-subscription-details>
  </div>
</div>
